import {Component} from '@angular/core';
import { SpinnerService} from '../Services/spinner';


@Component({
  selector: 'spinner-component',
  templateUrl: '../Templates/spinner.html',
  styleUrls: ['../Styles/spinner.css']
})


export class SpinnerComponent {
  public active: boolean;

  public constructor(spinner: SpinnerService) {

    spinner.status.subscribe((status: boolean) => {
      this.active = status;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/spinner.ts